export type OnlineBookingTab = "overview" | "betrieb" | "regeln" | "strecke" | "angebot";

export interface OnlineBookingSection {
  id: OnlineBookingTab;
  label: string;
  shortLabel: string;
  description: string;
}

export interface OnlineBookingTabGroup {
  label: string;
  tabs: OnlineBookingTab[];
}

export const ONLINE_BOOKING_SECTIONS: OnlineBookingSection[] = [
  {
    id: "overview",
    label: "Überblick",
    shortLabel: "Überblick",
    description: "Was die Online-Buchung leistet und wie Sie starten",
  },
  {
    id: "betrieb",
    label: "Betrieb",
    shortLabel: "Betrieb",
    description: "Website aktivieren, Buchungsmodus und Benachrichtigungen",
  },
  {
    id: "regeln",
    label: "Verfügbarkeit",
    shortLabel: "Regeln",
    description: "Saisons, Mindestaufenthalt und Same-Day-Cutoff",
  },
  {
    id: "strecke",
    label: "Buchungsstrecke",
    shortLabel: "Strecke",
    description: "Schritte und Formularfelder für Gäste",
  },
  {
    id: "angebot",
    label: "Angebot",
    shortLabel: "Angebot",
    description: "Anreisearten, Zusatzartikel und Kategorie-Darstellung",
  },
];

export const ONLINE_BOOKING_TAB_GROUPS: OnlineBookingTabGroup[] = [
  { label: "Einstieg", tabs: ["overview"] },
  { label: "Betrieb", tabs: ["betrieb"] },
  { label: "Gäste", tabs: ["regeln", "strecke"] },
  { label: "Verkauf", tabs: ["angebot"] },
];

export function parseOnlineBookingTab(value: string | null): OnlineBookingTab {
  if (
    value === "betrieb" ||
    value === "regeln" ||
    value === "strecke" ||
    value === "angebot"
  ) {
    return value;
  }
  return "overview";
}

export function onlineBookingTabHref(tab: OnlineBookingTab): string {
  return tab === "overview" ? "/stammdaten/online-buchung" : `/stammdaten/online-buchung?tab=${tab}`;
}

export function onlineBookingTabHrefWithSection(
  tab: OnlineBookingTab,
  section?: string | null,
): string {
  const base = onlineBookingTabHref(tab);
  if (!section) return base;
  const separator = base.includes("?") ? "&" : "?";
  return `${base}${separator}section=${section}`;
}
